export default class DesignConsistency {
  static init() {
    DesignConsistency.addSpacerClassToNecessaryRows();
    DesignConsistency.checkHeroChildrenContainerForComplexContent();
  }

  static addSpacerClassToNecessaryRows() {
    const preSelector = '.vc_row:not(.vc_row-no-padding) .vc_column-inner > .wpb_wrapper > ';
    const selector = `${preSelector} .no-spacer, ${preSelector} .gform_wrapper`;

    $(selector).each((idx, element) => {
      const ancestors = $(element).parentsUntil('.vc_row:not(.vc_inner)');

      if (ancestors && ancestors.length > 0 && !ancestors.is('.adds-own-spacer')) {
        const oldestAncestorThatCouldBeChildOfRow = ancestors[ancestors.length - 1];

        if (oldestAncestorThatCouldBeChildOfRow) {
          const parent = $(oldestAncestorThatCouldBeChildOfRow).parent();

          if (parent && parent.hasClass('vc_row')) {
            parent.addClass('add-spacer');
          }
        }
      }
    });
  }

  static checkHeroChildrenContainerForComplexContent() {
    const container = $('.hero-children-container');
    const noOfRows = container.find('.vc_row.vc_inner').length;
    const noOfColumns = container.find('.vc_row.vc_inner .wpb_column').length;

    if (noOfRows >= 1 && noOfColumns > 1) {
      container.removeClass('adds-own-spacer').addClass('complex-content');
    }
  }
}
